import React, { Component } from "react";
import { Link } from "react-router-dom";

import SignHeader from "../component/SignHeader";

import "../scss/style.scss";
import "../scss/sign.scss";

class Home extends Component {
	render() {
		return (
			<React.Fragment>
				<SignHeader />
				<div className="signMapLayout">
					<div className="libraryGuide">
						<p className="libraryTxt">지도에서 도서관을 찾아 클릭해 주세요.</p>
					</div>
					<div className="libraryMap">지도나옴</div>
				</div>
			</React.Fragment>
		);
	}
}

export default Home;
